import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="relative min-h-screen bg-obsidian text-pearl flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <span className="label-overline">404 · not found</span>
        <h1 className="mt-5 font-serif-display text-pearl text-6xl sm:text-7xl tracking-tight leading-none">
          A <span className="italic text-bone">letter</span>
          <br />
          gone astray.
        </h1>
        <p className="mt-8 text-ash text-[15px] leading-relaxed">
          The page you're looking for isn't here. It may never have existed —
          or it's been quietly archived.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="group mt-10 inline-flex items-center gap-2 rounded-lg bg-[#1E3A5F] text-white px-5 py-2.5 text-[12px] font-medium tracking-wide hover:bg-[#2A4A75] transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5 transition-transform duration-300 group-hover:-translate-x-0.5" />
          Back to W
        </Link>
      </div>
    </main>
  );
}
